import React, { useState, useContext, useEffect } from 'react';
import UserLicensesForm from '../../components/UserManagement/UserLicensesForm';
import PaymentsAPI from 'api/PaymentsAPI';
import { GlobalContext } from 'providers/GlobalProvider';

interface ILicenseEditsProps {
  user: any;
  team: any;
  setEditMode: any;
  handleTabChange: any;
}

const LicenseEdit: React.FC<ILicenseEditsProps> = ({ handleTabChange, setEditMode, user, team }) => {
  const { cur_user } = useContext(GlobalContext);
  const [ customerId, setCustomerId ] = useState<any>('');

  const getMatchedCusId = () => {
    cur_user.stripe_cus_info.map((cus: any) => {
      if (cus.name === team.name) {
        setCustomerId(cus.id);
      }
    });
  };

  const createCustomerPortalSession = async(cus_id: string) => {
    const res = await PaymentsAPI.createCustomerPortalSession(cus_id);
    if (res.success) {
      window.location.assign(res.result);
    }
  };

  useEffect(() => {
    getMatchedCusId();
  }, []);

  return (
    <div className='license-edit-container'>
      <div className='license-edit-header'>
        <div className='license-edit-header-user-info'>
          <div className='license-edit-header-section'>
            <div className='license-edit-header-name-text'>
              {user.firstName ? user.firstName : ''} {user.lastName ? user.lastName : ''}
            </div>
          </div>
          <div className='license-edit-header-section'>
            <div className='license-edit-header-email-text'>
              {user.email ? user.email : ''}
            </div>
          </div>
        </div>
        <div className='license-edit-close-btn' onClick={() => setEditMode(false)}>
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
            <path d='M18 6L6 18M6 6L18 18' stroke='#C2C2C2' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
          </svg>
        </div>
      </div>
      <div className='assign-licenses-container'>
        <div className='assign-licenses-header'>
          <div className='assign-licenses-header-text'>
            Assign Licenses
          </div>
        </div>
        <UserLicensesForm
          cusId={customerId}
          createCustomerPortalSession={createCustomerPortalSession}
          setEditMode={setEditMode}
          team={team}
          user={user}
          handleTabChange={handleTabChange}
        />
      </div>
    </div>
  );
};

export default LicenseEdit;
